import loggerService from '@/services/logger.service';

// Marks that this tab already had a live MM socket for an event. A page reload keeps sessionStorage,
// so the first socket open after a mid-event reload can tell itself apart from a true first entry and
// refetch uber to recover socket messages missed while the page was reloading.
const SOCKET_SESSION_MARKER_PREFIX = 'gc_mm_connected_';

export function hasSocketSessionMarker(eventID: string): boolean {
  if (!eventID) {
    return false;
  }
  try {
    return window.sessionStorage.getItem(SOCKET_SESSION_MARKER_PREFIX + eventID) === '1';
  } catch (error) {
    loggerService.warn('error reading socket session marker', error);
    return false;
  }
}

export function setSocketSessionMarker(eventID: string) {
  if (!eventID) {
    return;
  }
  try {
    window.sessionStorage.setItem(SOCKET_SESSION_MARKER_PREFIX + eventID, '1');
  } catch (error) {
    loggerService.warn('error writing socket session marker', error);
  }
}

export function clearSocketSessionMarkers() {
  try {
    Object.keys(window.sessionStorage)
      .filter(key => key.startsWith(SOCKET_SESSION_MARKER_PREFIX))
      .forEach(key => window.sessionStorage.removeItem(key));
  } catch (error) {
    loggerService.warn('error clearing socket session markers', error);
  }
}
